import React from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// import { Link } from 'gatsby';

class HealthcareIntro extends React.Component {
  componentDidMount() {
    if (typeof window !== `undefined`) {
      gsap.registerPlugin(ScrollTrigger);
      gsap.core.globals('ScrollTrigger', ScrollTrigger);
    }

    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray('.text-highlight').forEach((highlight) => {
      ScrollTrigger.create({
        trigger: highlight,
        start: '-100px center',
        onEnter: () => highlight.classList.add('active'),
      });
    });
  }
  render() {
    return (
      <div className="healthcareIntroWrap" data-highlight="half">
        <h2 className="text-highlight">Health Care Projects</h2>
        <p>
          Silencerは多様性が爆発した社会に向けてヘルスコア、プロダクト、プレイス、精神的、肉体的、社会的、あらゆる角度から健康を拡張させます。人間が健康に生きることは地球への最終回答ではないかと。わたしたちはいま一度ヘルスケアの未来、地球の未来を考え、地球上全人類の健康をアップデートさせるプロジェクトを産み落としていきます。
        </p>
        {/* <div className="image-wrapper">
          <svg viewBox="0 0 144.74 144.74">
            <defs>
              <style
                dangerouslySetInnerHTML={{
                  __html:
                    '.clsHealthcare-1{fill:none;}.clsHealthcare-2{fill:#231815;}',
                }}
              />
            </defs>
            <g id="layer_2" data-name="layer 2">
              <g id="layer_1-2" data-name="layer 1">
                <rect
                  className="clsHealthcare-1"
                  width="144.74"
                  height="144.74"
                />
                <path
                  className="clsHealthcare-2"
                  d="M85.08,38A2.72,2.72,0,0,0,83.15,43a30.47,30.47,0,1,1-21.57,0A2.72,2.72,0,0,0,59.66,38a35.9,35.9,0,1,0,25.42,0Z"
                />
                <path
                  className="clsHealthcare-2"
                  d="M61.18,62.67a10.41,10.41,0,0,0,5.48,9.49l8,4.85a4,4,0,0,1,2.15,3.67,4.41,4.41,0,0,1-1.22,3.15,4.09,4.09,0,0,1-3.1,1.28h-.2a6,6,0,0,1-4.94-2.42,3.31,3.31,0,0,0-2.72-1.32,3.37,3.37,0,0,0-2.09.69,3.43,3.43,0,0,0-.62,4.78A12.46,12.46,0,0,0,72.23,92h.21a10.92,10.92,0,0,0,6.74-2.25,10.61,10.61,0,0,0,4-5.92,11.61,11.61,0,0,0,.42-3.11,10.42,10.42,0,0,0-5.42-9.48l-8-4.88A4,4,0,0,1,68,62.66a4.42,4.42,0,0,1,1.21-3.14,4.05,4.05,0,0,1,3.09-1.28h.2a5.87,5.87,0,0,1,4.92,2.49,3.35,3.35,0,0,0,2.77,1.32,3.17,3.17,0,0,0,2-.7,3.11,3.11,0,0,0,1.39-2.7,3.54,3.54,0,0,0-.7-2.08,12.37,12.37,0,0,0-10.35-5.19H72.3a10.75,10.75,0,0,0-6.73,2.25,11,11,0,0,0-4,5.92A11.73,11.73,0,0,0,61.18,62.67Z"
                />
                <path
                  className="clsHealthcare-2"
                  d="M72.37,26a4.15,4.15,0,0,0,4.09-4.09A3.91,3.91,0,0,0,75.24,19a4.08,4.08,0,0,0-5.74,0,4,4,0,0,0,0,5.79A3.93,3.93,0,0,0,72.37,26Z"
                />
              </g>
            </g>
          </svg>
        </div> */}
      </div>
    );
  }
}

export default HealthcareIntro;
